module.exports = __webpack_public_path__ + "img/aheadworks.2cd8a5fc.jpg";